import {
  BankDetails,
  CompanyProfileOne,
  CompanyProfileTwo,
  CreateProfile,
  BusinessType,
  SuccessFullRegister,
} from '../../views/index.view';

export default function route() {
  return [
    {
      path: accessRegisterRoute.REGISTER.path,
      private: false,
      name: 'Create Profile',
      key: accessRegisterRoute.REGISTER.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.REGISTER.icon,
      element: <CreateProfile />,
    },
    {
      path: accessRegisterRoute.COMPANY_PROFILE_ONE.path,
      private: false,
      name: 'Company Profile One',
      key: accessRegisterRoute.COMPANY_PROFILE_ONE.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.COMPANY_PROFILE_ONE.icon,
      element: <CompanyProfileOne />,
    },
    {
      path: accessRegisterRoute.COMPANY_PROFILE_TWO.path,
      private: false,
      name: 'Company Profile Two',
      key: accessRegisterRoute.COMPANY_PROFILE_TWO.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.COMPANY_PROFILE_TWO.icon,
      element: <CompanyProfileTwo />,
    },
    {
      path: accessRegisterRoute.BUSINESS_TYPE.path,
      private: false,
      name: 'Business Type',
      key: accessRegisterRoute.BUSINESS_TYPE.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.BUSINESS_TYPE.icon,
      element: <BusinessType />,
    },
    {
      path: accessRegisterRoute.BANK_DETAILS.path,
      private: false,
      name: 'Bank Details',
      key: accessRegisterRoute.BANK_DETAILS.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.BANK_DETAILS.icon,
      element: <BankDetails />,
    },
    {
      path: accessRegisterRoute.SUCCESS_FULL_REGISTER.path,
      private: false,
      name: 'Register',
      key: accessRegisterRoute.SUCCESS_FULL_REGISTER.path,
      belongsToSidebar: false,
      icon: accessRegisterRoute.SUCCESS_FULL_REGISTER.icon,
      element: <SuccessFullRegister />,
    },
  ];
}

export const accessRegisterRoute = {
  REGISTER: {
    path: '/nca/register',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
  COMPANY_PROFILE_ONE: {
    path: '/nca/register-company-step-one',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
  COMPANY_PROFILE_TWO: {
    path: '/nca/register-company-step-two',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
  BUSINESS_TYPE: {
    path: '/nca/register-business-type',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
  BANK_DETAILS: {
    path: '/nca/register-bank-details',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
  SUCCESS_FULL_REGISTER: {
    path: '/nca/successfully-register',
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-grid-alt" />
      </span>
    ),
  },
};

export const getRegisterRoutes = () => {
  return route();
};
